<template>
  <div class="boxLittle">
    <!--<div class="navTitle">当前位置：益书宝首页 </div>-->
    <div class="boxTop">
      <div class="leftLogo">
        <img class="jgLogo" :src="touXiang" alt="" v-if="touXiang">
        <img class="jgLogo" src="../../../assets/images/moren.jpeg" alt="" v-else>
        <div class="nikname">{{jgname}}</div>
      </div>
      <div class="rightCz">
        <div class="caTop">
          <div @click="to('/home/mbzxBanKuai/zyMuBan')">
            <img src="../../../assets/images/xuanzemuban.png" alt="">
            <p>选择模板</p>
          </div>
          <div @click="to('/home/zncgBanKuai')">
            <img src="../../../assets/images/bianjineirong.png" alt="">
            <p>编辑内容</p>
          </div>
          <div @click="to('/home/zncgBanKuai')">
            <img src="../../../assets/images/neirongbaocun.png" alt="">
            <p>内容保存</p>
          </div>
          <div @click="to('/home/mbzxBanKuai/zyMuBan')">
            <img src="../../../assets/images/changyongmuban.png" alt="">
            <p>常用模板</p>
          </div>
        </div>
        <div class="caTop margin-top-sm">
          <div @click="to('/home/zxwzBanKuai')">
            <img src="../../../assets/images/zuixinwenzhang.png" alt="">
            <p>最新文章</p>
          </div>
          <!--<div>-->
            <!--<img src="../../../assets/images/daoru.png" alt="">-->
            <!--<p>导入文章</p>-->
          <!--</div>-->
          <div @click="to('/home/wdwzBanKuai')">
            <img src="../../../assets/images/daochu.png" alt="">
            <p>导出文章</p>
          </div>
          <div @click="to('/home/hszBanKuai')">
            <img src="../../../assets/images/huishouzhan.png" alt="">
            <p>回收站</p>
          </div>
            <div @click="to('/home/feedback')">
            <img src="../../../assets/images/tab1.png" alt="">
            <p>意见反馈</p>
          </div>
        </div>
      </div>
    </div>
    <div class="boxBottom">
      <div class="zjMb">
        <div class="ZJmbtit">最近常用模板</div>
        <div class="listBox">
          <div class="list" v-for="item in MBlist" :key="item.id">
            <p class="mbName" @click="yl(item.artid)">{{item.title}}</p>
            <p class="mbTime">
              <span class="time">{{item.addtime}}</span>
              <span class="chak" @click="yl(item.artid)">查看</span>
            </p>
          </div>
          <div class="wu" v-show="MBpage.MBpageTotal < 1">暂无更多...</div>
        </div>
        <div class="pageBox" v-show="MBpage.MBpageTotal > 0">
          <span @click="MBpage.MBpageNum = 1">首页</span>
          <el-pagination
            background
            @size-change="MBhandleSizeChange"
            @current-change="MBhandleCurrentChange"
            :current-page.sync="MBpage.MBpageNum"
            :page-size="MBpage.MBpageSize"
            layout="prev, pager, next"
            :total="MBpage.MBpageTotal">
          </el-pagination>
          <span @click="MBpage.MBpageNum = MBpage.MBpageCount">尾页</span>
        </div>
      </div>
      <div class="zjMb">
        <div class="ZJmbtit active">最近编辑文章</div>
        <div class="listBox">
          <div class="list" v-for="item in WZlist" :key="item.id">
            <p class="mbName" @click="yl2(item.artid)">{{item.title}}</p>
            <p class="mbTime">
              <span class="time">{{item.addtime}}</span>
              <span class="chak" @click="yl2(item.artid)">查看</span>
            </p>
          </div>
          <div class="wu" v-show="WZpage.WZpageTotal < 1">暂无更多...</div>
        </div>
        <div class="pageBox" v-show="WZpage.WZpageTotal > 0">
          <span @click="WZpage.WZpageNum = 1">首页</span>
          <el-pagination
            background
            @size-change="WZhandleSizeChange"
            @current-change="WZhandleCurrentChange"
            :current-page.sync="WZpage.WZpageNum"
            :page-size="WZpage.WZpageSize"
            layout="prev, pager, next"
            :total="WZpage.WZpageTotal">
          </el-pagination>
          <span @click="WZpage.WZpageNum = WZpage.WZpageCount">尾页</span>
        </div>
      </div>
      <!--<div class="boxBottomLeft">-->
      <!--<router-view @setAct="setAct"/>-->
      <!--</div>-->

    </div>
    <noticeTwo v-if="!isDetail" v-bind:idProps="id" v-bind:is-detail="isDetail"
    @watchState="watchState"></noticeTwo>
    <noticeThree v-if="!isDetail2" v-bind:idProps="id" v-bind:is-detail="isDetail2"
               @watchState="watchState2"></noticeThree>
  </div>
</template>

<script>
  import noticeTwo from '../../../components/noticeTwo'
  import noticeThree from '../../../components/noticeThree'

  export default {
    name: "syBanKuai",
    data() {
      return {
        touXiang: '',
        jgname:'',
        hotList: [], // 热点模板列表
        MBlist: [], // 模板列表
        WZlist: [], // 文章列表
        isDetail: true,  // 预览打开
        isDetail2: true,  // 预览打开
        id: '', // 操作的模板id
        MBpage: { // 模板分页
          MBpageNum: 1, // 当前页数
          MBpageSize: 8, // 每页显示条数
          MBpageTotal: 8, // 总条数
          MBpageCount: 1, // 总页数
        },
        WZpage: { // 文章分页
          WZpageNum: 1, // 当前页数
          WZpageSize: 8, // 每页显示条数
          WZpageTotal: 8, // 总条数
          WZpageCount: 1, // 总页数
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.touXiang = this.user.mthumb
      this.jgname = this.user.mnickname
      this.$emit('setIsAct', 1)
      this.MBgetList()
      this.WZgetList()
    },
    methods: {
      // 预览
      yl(id) {
        this.id = String(id)
        this.isDetail = false
      },
      // 预览
      yl2(id) {
        this.id = String(id)
        this.isDetail2 = false
      },
      // 详情关闭
      watchState(blon) {
        this.isDetail = blon
      },
      watchState2(blon) {
        this.isDetail2 = blon
      },
      // 最近常用
      MBgetList() {
        this.$api.apiAdmin.useoften({
          mid: this.user.mid,
          kind:2,
          page: this.MBpage.MBpageNum,
          pagesize: this.MBpage.MBpageSize
        }).then(res => {
          console.log(res)
          this.MBlist = res.data.data
          var List = res.data.data
          List.map(item => {
            item.addtime = this.$tools.ZHDate(new Date(item.addtime * 1000), 3)
          })
          this.MBpage.MBpageTotal = res.data.pageinfo.count
          this.MBpage.MBpageCount = Math.ceil(Number(res.data.pageinfo.count) / Number(this.page.pageSize))
        }).catch(() => {
          // this.$messageError(res.msg);
        })
      },
      // 最近打开
      WZgetList() {
        this.$api.apiAdmin.useoften({
          mid: this.user.mid,
          kind:3,
          page: this.WZpage.WZpageNum,
          pagesize: this.WZpage.WZpageSize
        }).then(res => {
          console.log(res)
          this.WZlist = res.data.data
          var List = res.data.data
          List.map(item => {
            item.addtime = this.$tools.ZHDate(new Date(item.addtime * 1000), 3)
          })
          this.WZpage.WZpageTotal = res.data.pageinfo.count
          this.WZpage.WZpageCount = Math.ceil(Number(res.data.pageinfo.count) / Number(this.page.pageSize))
        }).catch(() => {
          // this.$messageError(res.msg);
        })
      },
      // 跳转智能成稿
      toZn() {
        this.$router.push("/home/zncgBanKuai")
      },
      // 跳转智能成稿
      to(path) {
        this.$router.push(path)
      },
      // 跳转模板成稿
      toMb() {
        this.$router.push("/home/mbzxBanKuai/zyMuBan")
      },
      // 点击分页
      MBhandleSizeChange(num) {
        this.MBpage.MBpageNum = num
        this.MBgetList()
      },
      // 选择页数
      MBhandleCurrentChange(num) {
        this.MBpage.MBpageNum = num
        this.MBgetList()
      },
      // 点击分页
      WZhandleSizeChange(num) {
        this.WZpage.WZpageNum = num
        this.WZgetList()
      },
      // 选择页数
      WZhandleCurrentChange(num) {
        this.WZpage.WZpageNum = num
        this.WZgetList()
      },
    },
    components: {
      noticeTwo,
      noticeThree
    },
  }
</script>

<style scoped lang="scss">
  .act {
    color: #ffffff !important;
    background-color: #c60009 !important;
  }

  .boxLittle {
    width: 1220px;
    margin: 0 auto;
    min-width: 1200px;
    padding: 10px 0;
    /*overflow-x: scroll;*/
    .navTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-size: 14px;
    }

    .boxTop {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .leftLogo {
        width: 200px;
        height: 230px;
        background-color: #0a2240;
        border-radius: 4px;
        text-align: center;

        .jgLogo {
          width: 76px;
          height: 76px;
          border-radius: 47px;
          margin-top: 45px;
        }

        .nikname {
          width: 160px;
          margin: 15px auto;
          font-size: 14px;
          color: #ffffff;
          text-align: center;
        }
      }

      .rightCz {
        width: 992px;
        height: 230px;
        background-color: #0a2240;
        border-radius: 4px;
        padding: 20px;

        .caTop {
          width: 100%;
          display: flex;
          justify-content: space-between;
          div:hover {
            background-image: linear-gradient(37deg,
              #ffb400 0%,
              #fc7802 100%),
            linear-gradient(
                #0a2240,
                #0a2240);
            background-blend-mode: normal,
            normal;
            p{
              color: #fff;
            }
          }
          div {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 225px;
            height: 82px;
            text-align: center;
            background-color: #fff;
            cursor: pointer;
            img {
              width: 24px;
              height: 24px;
            }

            p {
              margin-left: 10px;
              text-align: center;
              color: #0a2240;
              font-size: 20px;
              font-weight: bold;
            }
          }
        }

        .cabottom {
          width: 100%;
          padding-top: 20px;
          display: flex;
          justify-content: space-between;
          div:hover {
            background-image: linear-gradient(37deg,
              #ffb400 0%,
              #fc7802 100%),
            linear-gradient(
                #0a2240,
                #0a2240);
            background-blend-mode: normal,
            normal;
            p{
              color: #fff;
            }
          }
          div {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 305px;
            height: 82px;
            text-align: center;
            background-color: #fff;
            cursor: pointer;
            img {
              width: 24px;
              height: 24px;

            }

            p {
              margin-left: 10px;
              text-align: center;
              color: #0a2240;
              font-size: 20px;
              font-weight: bold;
            }
          }
        }
      }
    }

    .boxBottom {
      width: 100%;
      height: 544px;
      margin-top: 20px;
      margin-bottom: 50px;
      display: flex;
      justify-content: space-between;

      .zjMb {
        width: 592px;
        height: 544px;
        padding: 25px;
        background-color: #ffffff;
        box-shadow: 0px 0px 13px 0px rgba(0, 138, 255, 0.16);

        .ZJmbtit {
          width: 100%;
          padding-left: 35px;
          height: 50px;
          font-size: 20px;
          color: #000;
          font-weight: bold;
          border-bottom: 1px solid #eee;
          line-height: 50px;
          background: url("../../../assets/images/mb-icon.png") no-repeat left center;
          background-size: 27px 27px;
          &.active{
            background: url("../../../assets/images/wz-icon.png") no-repeat left center;
            background-size: 27px 27px;
          }
        }

        .listBox {
          width: 100%;
          .wu {
            width: 100%;
            text-align: center;
            font-size: 14px;
            color: #999;
            padding-top: 150px;
          }
          .list {
            width: 100%;
            height: 45px;

            .mbName {
              float: left;
              width: 350px;
              height: 45px;
              line-height: 45px;
              font-size: 16px;
              color: #333333;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;
            }
            .mbName:hover {
              color: #0a2240;
            }

            .mbTime {
              width: 150px;
              float: right;
              height: 45px;
              line-height: 45px;

              .time {
                font-size: 14px;
                color: #999;
              }

              .chak {
                font-size: 14px;
                color: #0a2240;
                margin-left: 20px;
                cursor: pointer;
              }
            }
          }
        }

        .pageBox {
          margin-top: 40px;
          display: flex;
          justify-content: center;
          margin-bottom: 80px;

          span {
            border-radius: 4px;
            background-color: #fff;
            padding: 6px 10px;
            border: 1px solid #f2f2f2;
            font-size: 14px;
            color: #666666;
            cursor: pointer;
          }

        }

      }
    }
  }

</style>
